// Veercal gauges, v2 ("Tell-tale"), for the React app.
// Static-page equivalent: public/design/v2/gauges.js. Keep the two drawing the same.
//
// <Level value={0.27} label="Interest is 27% of the total" />  HOW MUCH (share 0 to 1)
// <Meter value={r.lit} label={r.aria} />  HOW IT RATES (1 to 5; r from meterRules.js, the only approved meters)
// Chart tube: <Level value={0.57} width={56} height={220} gap={4} top={tokensV2.tint} fill={tokensV2.ink} />
//
// Gauges only display values the engines have already calculated. The number
// or rating must also appear as text next to the gauge. See docs/brand/DESIGN.md.

import React from 'react';
import { tokensV2 as t } from './tokens';

const SIZES = { sm: [12, 48], md: [14, 56], lg: [24, 96] };
const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
const gapFor = (h) => Math.max(2, Math.round(h * 0.05));

export const meterBand = (n) => (n <= 2 ? 'green' : n <= 4 ? 'amber' : 'red');

function a11y(label) {
  return label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': 'true' };
}

export function Level({ value, size = 'md', width, height, gap: gapProp, label, top = t.ink, fill = t.amber }) {
  const [sw, sh] = SIZES[size] || SIZES.md;
  const w = width || sw;
  const h = height || sh;
  const gap = gapProp != null ? gapProp : gapFor(h);
  const fh = Math.round(h * clamp(Number(value) || 0, 0, 1) * 10) / 10;
  const th = Math.max(0, Math.round((h - fh - gap) * 10) / 10);
  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} {...a11y(label)} style={{ display: 'block', flex: 'none' }}>
      <rect x="0" y="0" width={w} height={th} rx="2" fill={top} data-part="empty" />
      <rect x="0" y={h - fh} width={w} height={fh} rx="2" fill={fill} data-part="fill" />
    </svg>
  );
}

export function Meter({ value, size = 'md', label }) {
  const [w, h] = SIZES[size] || SIZES.md;
  const of = 5;
  const gap = gapFor(h);
  const n = clamp(Math.round(Number(value) || 0), 0, of);
  const lit = t[meterBand(n)];
  const sh = (h - (of - 1) * gap) / of;
  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} {...a11y(label)} style={{ display: 'block', flex: 'none' }}>
      {Array.from({ length: of }, (_, i) => (
        <rect
          key={i}
          x="0"
          y={(h - (i + 1) * sh - i * gap).toFixed(1)}
          width={w}
          height={sh.toFixed(1)}
          rx="2"
          fill={i < n ? lit : t.ink}
          fillOpacity={i < n ? 1 : t.gauge.meterUnlitOpacity}
          data-lit={i < n ? 'true' : 'false'}
        />
      ))}
    </svg>
  );
}
